import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconPencil: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="pencil, edit, write"><path d="M16.5 3L21 7.5L17.75 10.75L7.25 21.25H2.75V16.75L13.25 6.25L16.5 3Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/><path d="M13.25 6.25L17.75 10.75" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/></CentralIconBase>;
};

export default IconPencil;
